import React, { useState, useEffect } from "react";
import IconButton from "../../../share/buttons/IconButton";
import Card from "../../../share/cards/Card";
import { ReactComponent as Trash } from "../../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../../Assets/Image/svg/edit.svg";
import { ReactComponent as Add } from "../../../../Assets/Image/svg/addSession.svg";
import EmptyCourseDash from "../../../share/EmptyCourseDash/EmptyCourseDash";
import { Modal } from "../../../share/modal/Modal";
import { BsArrowLeft } from "react-icons/bs";
import { BtnPrimary } from "../../../share/buttons/Btn";
import { BsArrowRight } from "react-icons/bs";
import { ReactComponent as TicketDot } from "../../../../Assets/Image/svg/ticketDot.svg";
import QAInfo from "./QAInfo";
import useFetch from "../../../../Hooks/useFetch";
import MainPagination from "../../../share/Pageination/MainPagination";
import { useCreate } from "../../../../Context/CreateContext";

const CreateCourseQA = (props) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const [upload, setUpload] = useState(false);
    const [emptyPage, setEmptyPage] = useState(false);
    const [question, setQuestion] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
    });
    const [del, setDel] = useState();
    const [edit, setEdit] = useState(null);

    const handleModal = () => {
        setUpload((perv) => !perv);
    };
    const handlePage = () => {
        setEmptyPage(false);
        setEdit(null);
    };
    //

    const getFAQ = useFetch({
        method: "GET",
        url: `BootCampFaqService/${bootCamp.id}/faqs`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setQuestion,
    });

    const deleteFAQ = useFetch({
        method: "DELETE",
        url: `BootCampFaqService/${del}`,
        noHeader: false,
        caller: getFAQ,
    });

    useEffect(() => {
        getFAQ.reFetch();
    }, [pagination]);

    const handleDelete = (id) => {
        setDel(id);
        deleteFAQ.reFetch();
    };

    const handleEdit = (id) => {
        setEdit(id);
        setUpload(true);
    };

    return (
        <div className=" mt-20">
            {question.results?.length !== 0 ? (
                <>
                    <div className="flex justify-between items-center mb-20">
                        <h4 className="text-[2rem] text-purple-dark font-bold">
                            سوالات متداول بوت کمپ
                        </h4>
                        <BtnPrimary
                            text="+ افزودن سوال"
                            className="px-16 py-7"
                            onClick={() => handleModal()}
                        />
                    </div>
                    <Card className="SupportTicketTable-card SupportTicketTable-body  my-4 font-bold text-black-prim">
                        <div>متن سوال</div>
                        <div>پاسخ سوال</div>
                        <div></div>
                    </Card>
                    {question.results?.map((i) => (
                        <Card
                            key={i.id}
                            className="SupportTicketTable-card SupportTicketTable-body my-4 relative"
                        >
                            <div className=" absolute top-[31px] right-0">
                                <TicketDot />
                            </div>
                            <div className=" text-black-prim">
                                {i.faq_question}
                            </div>
                            <div>{i.faq_answer}</div>
                            <div className=" text-purple-dark cursor-pointer"></div>
                            <div className="">
                                {!i.checked && (
                                    <div className="flex justify-end">
                                        <IconButton
                                            data-tip="حذف"
                                            onClick={() => handleDelete(i.id)}
                                        >
                                            <Trash />
                                        </IconButton>
                                        <IconButton
                                            data-tip="ویرایش"
                                            onClick={() => handleEdit(i.id)}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </div>
                                )}
                            </div>
                        </Card>
                    ))}
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={question?.results}
                        pageSize={question?.page_count}
                        className="mt-[3rem]"
                    />
                    <div className="flex  justify-between items-center mt-20">
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.prevStep}
                        >
                            <BsArrowRight />
                            <span>مرحله قبل</span>
                        </div>
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.nextStep}
                        >
                            <span>ثبت و ادامه</span>
                            <BsArrowLeft />
                        </div>
                    </div>
                    <Modal show={upload} closeModal={handleModal}>
                        <QAInfo
                            close={handleModal}
                            id={edit}
                            setId={setEdit}
                            get={getFAQ}
                        />
                    </Modal>
                </>
            ) : (
                <>
                    <div>
                        <EmptyCourseDash name="سوال" show={setEmptyPage} />
                        <Modal show={emptyPage} closeModal={handlePage}>
                            <QAInfo
                                close={handlePage}
                                id={edit}
                                setId={setEdit}
                            />
                        </Modal>
                        <div className="flex  justify-between items-center mt-20">
                            <div
                                className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                                onClick={props.prevStep}
                            >
                                <BsArrowRight />
                                <span>مرحله قبل</span>
                            </div>
                            <div
                                className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                                onClick={props.nextStep}
                            >
                                <span>ثبت و ادامه</span>
                                <BsArrowLeft />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default CreateCourseQA;
